import { QnAConfigService } from './QnAConfigService';
import { QnAConfigStorageService } from './QnAConfigStorageService';
import { QnAConfigValidationService } from './QnAConfigValidationService';

export const storageService = new QnAConfigStorageService();
export const validationService = new QnAConfigValidationService();
export const configurationService = new QnAConfigService(storageService, validationService);

export { QnAConfigStorageService, QnAConfigValidationService, QnAConfigService };

export * from './types';
